const activeEngageReadyEvent = "common.dealerChat.activeEngageReady";

// IE workaround for custom events
(function () {
    /* istanbul ignore if  */
    if ( typeof window.CustomEvent === "function" ) {
        // Returning, this is a good browser.
        return false;
    }

    function CustomEvent ( event, params ) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent( 'CustomEvent' );
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();

window.CARS = window.CARS || {};
let cars = window.CARS;

cars.onActivEngageAvailable = function() {
    let event = new CustomEvent(activeEngageReadyEvent);
    window.document.body.dispatchEvent(event);
};

function activeEngageService ($window, $rootScope) {
    this.activeEngageReadyEvent = activeEngageReadyEvent;

    let activeEngageReady = angular.isDefined($window.ActivEngage);

    $window.document.body.addEventListener(activeEngageReadyEvent, (e) => {
        activeEngageReady = true;
        $rootScope.$apply((scope) => {
            scope.$broadcast(activeEngageReadyEvent);
        });
    });

    this.isActiveEngageReady = () => activeEngageReady;

    this.launchChat = ((payload) => $window.ActivEngage.launchChat({
        data: payload
    }));
}

activeEngageService.$inject = [
    '$window',
    '$rootScope'
];

export default activeEngageService;
